// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ny3J","type":"styles_type__2gkjB","choices":"styles_choices__2IGA0"};